// Permanent alias layer for the kiosk URLs.
//
// The wall-mounted displays carry room ids in their URLs that date from before Microsoft
// rotated the `id` field on every room in Graph's /places response. Rather than re-pointing
// each physical iPad whenever identifiers change, those legacy ids are kept as OPAQUE
// FRONTEND TOKENS and translated here to the room's placeId - which, unlike `id`, is stable
// across rotations. The API resolves rooms by id, placeId, mailbox address or display name,
// so the translated value keeps working no matter what Graph does to `id`.
//
// This file is deliberately permanent (it replaced a rotation-sensitive stopgap that mapped
// to the then-current `id` values). Maintenance:
//   - Existing displays: never touch them; their URLs are keys here.
//   - New displays: point them at the room's placeId (or mailbox address) directly - no
//     entry here is needed.
//   - If a room is renamed or replaced in Microsoft 365, update its placeId here only if
//     the placeId itself changed (it normally survives renames).
const KIOSK_ROOM_ALIASES = {
  '2aa28f12-ce4c-492d-ac29-0d3ed7d8b54e': '29e655dc-8215-4361-843b-fe04f707ae3f', // Starship (Front Corner)
  '6a2e50d9-a440-44e7-9239-11f51deaa029': '6886e0c9-ba09-495c-953d-a272a1f6febc', // Cosmos (Phone Call Room)
  'e7548332-7813-41b5-8fa9-cce398a2b14c': '6a264702-b0cd-41b9-be26-6da29b388857', // Deathstar (Near Entry)
  '55ff5a10-24b8-4050-b4db-d74061d04a89': '94f72456-98ef-41e2-9036-c51257262d72', // Galaxy (Back Corner)
  '1afe3261-1e14-4a05-a98a-b5a0498f399c': '95d80187-f8d3-4fe8-9eab-e98ae3ec0ea0', // Universe (Common Room)
  'ac8de72d-b21f-48ce-921f-eb8c0d4a66a7': '9de9e568-80e9-41b7-b0e3-6a2923cbee2c', // Nebula
};

// Translates a kiosk URL token to the room's stable placeId. Anything not in the table -
// a placeId, a current id, a mailbox address - is returned untouched, so this is safe to
// apply to every request.
export function resolveRoomId(roomId) {
  if (!roomId) return roomId;
  return KIOSK_ROOM_ALIASES[String(roomId).trim().toLowerCase()] ?? roomId;
}

export { KIOSK_ROOM_ALIASES };
